import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { EaChartAbstractComponent } from '../ea-chart-abstract/ea-chart-abstract.component';

@Component({
    selector: 'ea-venn-chart',
    templateUrl: './ea-venn-chart.component.html',
    styleUrls: ['./ea-venn-chart.component.scss'],
    standalone: false
})
export class EaVennChartComponent
  extends EaChartAbstractComponent<any>
  implements OnInit
{
  constructor(
    protected translate: TranslateService,
    protected changeDetectorRef: ChangeDetectorRef,
  ) {
    super(translate, changeDetectorRef);
  }
  @Input() unity: string = '';

  ngOnInit(): void {
    this._options = {
      ..._.merge(this._options, {
        chart: {
          backgroundColor: 'transparent',
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          spacingTop: 0,
          spacingBottom: 0,
          type: 'venn',
        },
        credits: {
          enabled: false,
        },
        tooltip: {
          formatter: function () {
            let val = this.point.trueValue
              ? this.point.trueValue
              : this.point.value;
            return (
              '<span style="color:' +
              this.point.color +
              '">●</span> ' +
              this.point.name +
              ': <b>' +
              val.toLocaleString('fr-FR', {
                useGrouping: true,
                minimumFractionDigits: 0,
              }) +
              ' %</b>'
            );
          },
          enabled: true,
          valueDecimals: 0,
        },
        plotOptions: {
          venn: {
            allowPointSelect: false,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              align: 'center',
              format: `<b>{${this.series[0]?.trueValue ? 'point.trueValue' : 'point.value'}} %</b>`,
              style: {
                color: 'white',
                textOutline: 'none',
                fontSize: '1.5rem',
              },
            },
            borderWidth: 0,
            opacity: 1,
          },
        },
        series: [
          {
            data: this.getValueInterpolation(),
          },
        ],
      }),
    };
  }

  getValueInterpolation() {
    let series = this.series || this._options.series;
    return series;
  }
}
